const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;
const JSON_BASE_URL = process.env.VUE_APP_JSON_BASE_URL;
const OMNIPRINT_BASE_URL = 'http://localhost:9090';

const baseUrl = ( url ) => `${ API_BASE_URL }/app-rest/${ url }`;
const cmaUrl = ( url ) => baseUrl( `cma/v1/${ url }` );
const adminUrl = ( url ) => baseUrl( `admin_portal/v1/${ url }` );
const logisticsUrl = ( url ) => baseUrl( `butler_logistics/v1/${ url }` );
const omniprintUrl = ( url ) => `${ OMNIPRINT_BASE_URL }/${ url }`;

const authHeaders = ( jwtToken ) => ( { 'Auth-Token': jwtToken } );

export default {
    API_BASE_URL,
    JSON_BASE_URL,
    authHeaders,
    baseUrl,
    cmaUrl,
    adminUrl,
    logisticsUrl,
    omniprintUrl,
};
